import Item from '../common/item'

const state = Object.assign({}, Item.state)
state.endpoint = 'account'
state.emptyValue = {
  account: {
    roles: []
  }
}
state.record = Object.assign({}, state.emptyValue)

export default{
  namespaced: true,
  state,
  getters: Item.getters,
  mutations: Item.mutations,
  actions: Item.actions
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/accounts/account.js